module.exports = __webpack_public_path__ + "static/media/intro.8b665b97.mp3";